import type { FC } from 'react';
import styled from 'styled-components';

import { Flex, ShortcutStyle } from '@/components/base';
import Transition from '@/components/Common/Transition';
import Portal from '@/components/Portal/Portal';

import type { TooltipState } from './type';

const TooltipRenderer: FC<TooltipState> = ({
  tooltipNode,
  style,
  visible,
  shortcut,
}) => {
  if (!tooltipNode) return null;
  return (
    <Portal id="tooltip-layer">
      <Transition
        status={!!tooltipNode && visible}
        style={{
          position: 'fixed',
          top: style.top ? 0 : undefined,
          bottom: style.bottom ? 0 : undefined,
          left: style.left ? 0 : undefined,
          right: style.right ? 0 : undefined,
        }}
      >
        <StyledTooltip style={style}>
          {tooltipNode}
          {shortcut && <ShortcutStyle>{shortcut}</ShortcutStyle>}
        </StyledTooltip>
      </Transition>
    </Portal>
  );
};

export const StyledTooltip = styled(Flex)`
  align-items: center;
  gap: 8px;
  position: fixed;
  pointer-events: none;
  user-select: none;
  padding: 8px 12px;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: ${(props) => props.theme.colors.FL100};
  background: ${(props) => props.theme.colors.FD100};
  border: 1px solid ${(props) => props.theme.colors.FL16};
  font-weight: 500;
  border-radius: 4px;
  width: max-content;
  min-width: min-content;
  max-width: 600px;
  white-space: normal;
  word-wrap: break-word;
`;

export default TooltipRenderer;
